"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useMemo } from "react";

export function useFullPath() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const fullPath = useMemo(() => {
    const queryString = searchParams.toString();
    return queryString ? `${pathname}?${queryString}` : pathname;
  }, [pathname, searchParams]);

  return fullPath;
}
